/**
 * Override Footer component.
 * @module components/r/Header
 * Reason for override: Modify Footer to add our text
 */

import Colophon from 'volto-portknox/components/Footer/Colophon';

export default Colophon;
